export default __webpack_public_path__ + "static/media/diverse03-1.5x.563411ce.png";